import styled from "styled-components";

export default styled.div`
    display: block;
    flex-basis: 0;
    flex-grow: 1;
    flex-shrink: 1;
    padding: 0.75rem;
`;



// WEBPACK FOOTER //
// ./bulma/grid/Column.tsx